import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab3 = ({
  IdData,
  TaxCategory,
  TaxID,
  TaxWithholdingCategory,
  GSTIN_UIN,
  PAN,
  GSTCategory,
}) => {
  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Purchasing Details</p>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <Input
              id="TaxID"
              label="Tax ID"
              style={{ height: "30px" }}
              value={TaxID.TaxID}
              readOnly
              onChange={(e) => TaxID.setTaxID(e.target.value)}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <Input label="Tax Category" readOnly value={TaxCategory.select_TaxCategory} style={{ height: "30px" }} />

          </div>
        </div>
        <div className="col-4">
          <div className="mb-3">
            <Input label="Tax With holding Category" readOnly value={TaxWithholdingCategory.select_TaxWithholdingCategory} style={{ height: "30px" }} />

          </div>
        </div>
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Tax Details</p>
        </div>
        <div className="col-4">
          <div className="mb-3">
            <Input
              readOnly
              id="GSTIN_UIN"
              label="GSTIN / UIN"
              style={{ height: "30px" }}
              value={GSTIN_UIN.GSTIN_UIN}
              onChange={(e) => GSTIN_UIN.setGSTIN_UIN(e.target.value)}
            />
          </div>
        </div>
        <div className="col-4">
          <div className="mb-3">
            <Input
              readOnly
              id="PAN"
              label="PAN"
              style={{ height: "30px" }}
              value={PAN.PAN}
              onChange={(e) => PAN.setPAN(e.target.value)}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <Input label="GST Category" readOnly value={GSTCategory.GSTCategory} style={{ height: "30px" }} />



          </div>
        </div>
      </div>
                     <div className="">
        <ActivityCard doctype="Supplier" docname={IdData} />
      </div>
       
    </>
  );
};

export default Tab3;
